/**
 * Returns the reason a customer cannot be imported, or undefined if valid.
 * Prioritises the API-provided invalidReason, then checks for a missing name.
 */
export const getCustomerInvalidReason = (customer: {
  invalidReason?: string
  companyName?: string | null
}): string | undefined => {
  if (customer.invalidReason) {
    return customer.invalidReason
  }
  if (!customer.companyName?.trim()) {
    return 'Missing company name.'
  }
  return undefined
}
